import { WorkHour } from "../../WorkHours/Models/workHour";
import api from "../../../../store/AuthHeader";

const getCountryData = () => {
    return api.get("/Country/GetAllCountries");
};

const getWorkHours = (querystring: any) => {
    return api.get("/WorkHour/GetAllWorkHours?" + querystring);
}

const addWorkHour = (payload: WorkHour) => {
    return api.post("/WorkHour", payload);
};

const getWorkHourById = (id: number) => {
    return api.get(`/WorkHour/GetWorkHourById?id=${id}`);
};

const updateWorkHour = (id: number, payload: any) => {
    return api.put(`/WorkHour/${id}`, payload);
};

const deleteWorkHourById = (itemToDeleteId: number) => {
    return api.delete(`/WorkHour/${itemToDeleteId}`);
};

const getWorkHourDetails = (queryStr: any, workHourId: any) => {
    return api.get("/WorkHour/GetAllWorkHourDetailsByWorkHourIdQuery?" + queryStr + '&id=' + workHourId);
}

const deleteWorkHourDetailsById = (itemToDeleteId: number) => {
    return api.delete(`/WorkHour/DeleteWorkHourDetail/${itemToDeleteId}`);
};

const getWorkhourTypes = () => {
    return api.get("/WorkHour/GetWorkHourTypes");
};

const addWorkHourDetails = (payload: any) => {
    return api.post("/WorkHour/CreateWorkHourDetails", payload);
};

const updateWorkHourDetails = (id: number, payload: any) => {
    return api.put(`/WorkHour/UpdateWorkHourDetails/${id}`, payload);
};

const getWorkHourDetailsById = (id: number) => {
    return api.get(`/WorkHour/GetWorkHourDetaulsById?id=${id}`);
};

const getAllRoleSubRoleContract = () => {
    return api.get(`/WorkHour/GetAllRoleSubRoleContract`);
};

export default {
    getCountryData,
    addWorkHour,
    getWorkHours,
    getWorkHourById,
    updateWorkHour,
    deleteWorkHourById,
    getWorkHourDetails,
    deleteWorkHourDetailsById,
    getWorkhourTypes,
    addWorkHourDetails,
    updateWorkHourDetails,
    getWorkHourDetailsById,
    getAllRoleSubRoleContract
};
